export default "<button class=\"back-button\" type=\"button\">\n    <em class= \"back-button__arrow\"></em>\n    Back\n</button>\n"